var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.649 2.35A7.965 7.965 0 007.995 0 7.992 7.992 0 000 8c0 4.42 3.572 8 7.995 8 3.732 0 6.844-2.55 7.735-6h-2.082c-.82 2.33-3.041 4-5.653 4a6.007 6.007 0 01-6.004-6c0-3.31 2.692-6 6.004-6 1.661 0 3.142.69 4.223 1.78L8.996 7H16V0l-2.351 2.35z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjY0ODUgMi4zNUMxMi4xOTc2IDAuOSAxMC4yMDY0IDAgNy45OTUgMEMzLjU3MjIzIDAgMCAzLjU4IDAgOEMwIDEyLjQyIDMuNTcyMjMgMTYgNy45OTUgMTZDMTEuNzI3MyAxNiAxNC44MzkzIDEzLjQ1IDE1LjcyOTggMTBIMTMuNjQ4NUMxMi44MjggMTIuMzMgMTAuNjA2NiAxNCA3Ljk5NSAxNEM0LjY4MjkzIDE0IDEuOTkxMjQgMTEuMzEgMS45OTEyNCA4QzEuOTkxMjQgNC42OSA0LjY4MjkzIDIgNy45OTUgMkM5LjY1NjAzIDIgMTEuMTM3IDIuNjkgMTIuMjE3NiAzLjc4TDguOTk1NjIgN0gxNlYwTDEzLjY0ODUgMi4zNVoiIC8+Cjwvc3ZnPgo=";
export { SvgRefresh as ReactComponent };